import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { CONTACT } from "../data/site";
import { useI18n } from "../i18n/LanguageContext";

const FooterLink = ({ l, className }) =>
  l.to ? (
    <Link to={l.to} className={className}>{l.label}</Link>
  ) : (
    <a href={l.href} className={className} {...(l.href.startsWith("http") ? { target: "_blank", rel: "noreferrer" } : {})}>{l.label}</a>
  );

export const Footer = () => {
  const { t } = useI18n();
  const f = t.footer;
  const COLS = [
    { title: f.explore, links: [
      { label: t.nav.projects, to: "/projects" },
      { label: t.nav.distress, to: "/distress" },
      { label: t.nav.about, to: "/about" },
      { label: t.nav.blog, to: "/blog" },
    ]},
    { title: f.company, links: [
      { label: t.nav.contact, to: "/contact" },
      { label: f.bookCall, href: CONTACT.calendly },
      { label: f.joinTeam, href: CONTACT.emailHref },
      { label: "Trustpilot", href: "https://nl.trustpilot.com/review/offplandubai.nl" },
    ]},
  ];

  return (
    <footer className="bg-navy" data-testid="footer">
      <div className="container-x py-16">
        <div className="grid gap-12 md:grid-cols-12">
          <div className="md:col-span-5">
            <Logo variant="light" />
            <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">{f.tagline}</p>
            <div className="mt-7 flex flex-col gap-2">
              <a href={CONTACT.whatsappHref} target="_blank" rel="noreferrer" className="w-fit text-sm font-medium text-gold-300 hover:text-gold-400" data-testid="footer-whatsapp">{CONTACT.whatsapp}</a>
              <a href={CONTACT.emailHref} className="w-fit text-sm text-white/80 hover:text-white" data-testid="footer-email">{CONTACT.email}</a>
            </div>
          </div>
          {COLS.map((col) => (
            <div key={col.title} className="md:col-span-2">
              <h4 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-white/50">{col.title}</h4>
              <ul className="mt-5 flex flex-col gap-3">
                {col.links.map((l) => (
                  <li key={l.label}><FooterLink l={l} className="text-sm text-white/80 transition-colors duration-300 hover:text-gold-300" /></li>
                ))}
              </ul>
            </div>
          ))}
          <div className="md:col-span-3">
            <h4 className="font-display text-sm font-semibold uppercase tracking-[0.14em] text-white/50">{f.office}</h4>
            <p className="mt-5 font-display text-2xl font-semibold leading-tight text-white">{f.cities}</p>
            <p className="mt-3 text-sm text-white/60">{f.officeSub}</p>
          </div>
        </div>
        <div className="mt-14 flex flex-col items-start justify-between gap-3 border-t border-white/10 pt-8 text-xs text-white/50 md:flex-row md:items-center">
          <span>© {new Date().getFullYear()} OffplanDubai.nl — {f.rights}</span>
          <span>{f.badges}</span>
        </div>
      </div>
    </footer>
  );
};
